import { connect } from 'react-redux';
import classnames from 'classnames';
import React from 'react';
import PropTypes from 'prop-types';

import { closeSidebar as closeSidebarImport } from '../shared/actions/navigation.actions';

class Body extends React.Component {
  static get propTypes() {
    return {
      navigation: PropTypes.object.isRequired,
      children: PropTypes.array.isRequired,
      closeSidebar: PropTypes.func.isRequired,
    };
  }

  constructor(props) {
    super(props);

    this.closeIfOpen = this.closeIfOpen.bind(this);
  }

  closeIfOpen(event) {
    const { navigation, closeSidebar } = this.props;
    if (navigation.sidebarEnabled && !event.target.closest('.left-side-menu')) {
      event.preventDefault();
      event.stopPropagation();
      closeSidebar();
    }
  }

  render() {
    const { navigation, children } = this.props;
    const navigationClasses = classnames({
      'sidebar-enable': navigation.sidebarEnabled,
    });

    /* eslint-disable  */
    return (
      <div className={navigationClasses} onClick={this.closeIfOpen}>
        {children}
      </div>
    );
    /* eslint-enabled */
  }
}

function mapStateToProps(state) {
  const { navigation } = state;
  return { navigation };
}

export default connect(mapStateToProps, {
  closeSidebar: closeSidebarImport,
})(Body);
